<app-header></app-header>
<div>
    <router-outlet></router-outlet>
</div>
<!-- <img src="../../assets/images/bg-image-blur.png" alt="" class="" width="100%" /> -->
<!-- <app-footer></app-footer> -->